const changeErrorMessage = error => error
  .replace('SyntaxError: ', '')
  .replace(/\[.+\]./g, '')
  .replace(/http:?.+/g, '')

export default changeErrorMessage
